import {
  Backdrop,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableSortLabel,
  TableContainer,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  Tooltip,
  Typography,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { CustomTextField } from '@uml/uml-components';
import { FormProvider, useForm } from 'react-hook-form';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import api from '../utilities/api';
import { getDistricts } from '../services/projects';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  withMargins: {
    padding: 16,
    margin: '20px auto',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
  },
  projectsType: {
    width: '100%',
    justifyContent: 'center',
    margin: '10px auto',
  },
  fullWidth: {
    width: '100%',
    '&:focus': {
      backgroundColor: theme.palette.primary.dark,
      color: '#FFFFFF',
    },
  },
  sortPanel: {
    width: '100%',
  },
  findText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rowReverse: {
    flexDirection: 'row-reverse',
  },
  wonRow: {
    backgroundColor: theme.palette.action.hover,
  },
  statusLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  wonProjectCell: {
    padding: '20px 15px',
    width: '100%',
    margin: '20px 0',
    display: 'flex',
    flexDirection: 'column',

    '&:nth-child(2n)': {
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3',
    },
    '& > div': {
      padding: '5px 0',
    },
  },
  cellTitle: {
    fontSize: '1.3rem',
    fontWeight: '700',
  },
  cellNumberAndDistrict: {
    display: 'flex',
    marginLeft: '10px',
    justifyContent: 'space-between',
  },
  cellNumber: {
    color: 'rgba(0, 0, 0, 0.9)',
  },
  cellVotes: {
    color: 'rgba(0, 0, 0, 0.65)',
  },
  cellStatusAndAction: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  MenuItemroot: {
    wordBreak: 'break-all',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  statusBar: {
    [theme.breakpoints.up('md')]: {
      marginRight: 15,
    },
  },
  maxWidth80: {
    maxWidth: '80%',
  },
  width100: {
    width: '100%',
  },
  chiptext: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));

const SORT_TYPES = [
  {
    name: 'Numer projektu: rosnąco',
    value: 'sorted_abbreviation,sorted_number_integer',
  },
  {
    name: 'Numer projektu: malejąco',
    value: '-sorted_abbreviation,-sorted_number_integer',
  },
];

const PROJECT_STATUS = ['Wybrany do realizacji', 'Niewybrany do realizacji'];

const statusLabel = (status, givenClass, givenColor, icon) => (
  <span className={givenClass} style={{ color: givenColor }}>
    {icon}
    {status}
  </span>
);

const WonProjectCell = ({ item }) => {
  const classes = useStyles();
  const theme = useTheme();
  const starColor =
    item.status === 'Wybrany do realizacji'
      ? theme.palette.success.dark
      : theme.palette.primary.dark;
  const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);

  const tooltipHandler = () => {
    setTooltipIsOpen((prev) => !prev);
  };

  return (
    <Box className={classes.wonProjectCell} boxShadow={3}>
      {item?.prize && <div>Miejsce {item.prize}</div>}
      <div className={classes.cellTitle}>{item.title}</div>
      <div className={classes.cellNumberAndDistrict}>
        <div className={classes.cellNumber}>
          <Chip
            label={item.number}
            variant='outlined'
            style={{ backgroundColor: theme.palette.action.hover }}
          />
        </div>
        {item?.district_name && (
          <div className={classes.maxWidth80}>
            <Tooltip
              open={tooltipIsOpen}
              placement='top'
              title={
                <Typography variant='body1'>{item.district_name}</Typography>
              }
            >
              <Chip
                label={<p className={classes.chiptext}>{item.district_name}</p>}
                icon={<MyLocationIcon />}
                variant='outlined'
                style={{ backgroundColor: theme.palette.action.hover }}
                className={classes.width100}
                onClick={tooltipHandler}
              />
            </Tooltip>
          </div>
        )}
      </div>
      <div className={classes.cellVotes}>Liczba głosów: {item.votes_count}</div>
      <div className={classes.cellStatusAndAction}>
        <div>
          {statusLabel(
            item.status,
            classes.statusLabel,
            starColor,
            item.status === 'Wybrany do realizacji' ? (
              <StarIcon />
            ) : (
              <StarBorderIcon />
            ),
          )}
        </div>
        <div>
          <IconButton
            href={`${previewUrl}?projectId=${item.id}`}
            title='Podgląd'
            aria-label='Podgląd'
          >
            <VisibilityIcon />
          </IconButton>
        </div>
      </div>
    </Box>
  );
};

const WonProjectsList = ({ editionId }) => {
  const classes = useStyles();
  const methods = useForm();
  const theme = useTheme();
  const [projects, setProjects] = React.useState([]);
  const [type, setType] = React.useState('Dzielnicowy');
  const [orderBy, setOrderBy] = React.useState('abbreviation,number_integer');
  const [orderType, setOrderType] = React.useState('asc');
  const [loading, setLoading] = React.useState(true);
  const [availableDistricts, setAvailableDistricts] = React.useState([]);
  const [ordering, setOrdering] = React.useState(SORT_TYPES[0].value);
  const [isMobile, setIsMobile] = React.useState(false);
  const [district, setDistrict] = React.useState('');
  const [status, setStatus] = React.useState('');
  const [searchTitle, setSearchTitle] = React.useState('');

  const handleResize = () => {
    setIsMobile(window.innerWidth < 960);
  };

  useEffect(() => {
    const fetchDistricts = async () => {
      const data = await getDistricts();
      const districts = await data.json();
      const choices = districts?.features ?? [];
      setAvailableDistricts(
        choices.map((choice) => ({
          id: choice.id,
          name: choice.properties.nazwa,
        })),
      );
    };
    fetchDistricts();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const tempSort = orderBy.includes(',')
        ? orderBy
            .split(',')
            .map((elem) => `${orderType === 'desc' ? '-' : ''}sorted_${elem}`)
            .join(',')
        : `${orderType === 'desc' ? '-' : ''}${
            orderBy === 'votes_count' ? '' : 'sorted_'
          }${orderBy}`;
      try {
        const { data } = await api.get(`/bo/projects/external-search/`, {
          params: {
            limit: 200,
            page: 1,
            project_range: type,
            cms_status: status || 'Wybrany do realizacji, Niewybrany do realizacji',
            edition__contains: editionId,
            ordering: isMobile ? ordering : tempSort,
            district,
            polish_text: searchTitle,
          },
        });
        setProjects(data.results);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    if (editionId !== '') {
      fetchData();
    }
  }, [
    district,
    editionId,
    ordering,
    orderBy,
    orderType,
    searchTitle,
    status,
    type,
  ]);

  const onSort = (property) => {
    const isAsc = orderBy === property && orderType === 'asc';
    setOrderType(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const changeType = (type) => {
    setStatus('');
    setDistrict('');
    setType(type);
  };

  const headers = [
    {
      name: 'Numer projektu',
      id: 'abbreviation,number_integer',
      sortable: true,
    },
    { name: 'Nazwa', id: 'title', sortable: true },
    { name: 'Liczba głosów', id: 'votes_count', sortable: true },
    { name: 'Status', id: 'status', sortable: true },
    { name: 'Akcje', id: 'actions', sortable: false },
  ];

  window.addEventListener('resize', handleResize);

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
      <Card className={classes.withMargins}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <FormProvider {...methods}>
          <form id='search-form'>
            <Grid container className={classes.sortPanel}>
              <Grid xs={12} sm={10} item className={classes.searchText}>
                <div className={classes.root}>
                  <CustomTextField
                    size='small'
                    id='projectTitle'
                    label='Fraza do wyszukania'
                    variant='outlined'
                    name='text'
                  />
                </div>
              </Grid>
              <Grid xs={12} sm={2} item className={classes.findText}>
                <Button
                  variant='contained'
                  color='primary'
                  type='submit'
                  onClick={(e) => {
                    e.preventDefault();
                    setSearchTitle(methods.getValues().text);
                  }}
                >
                  Szukaj
                </Button>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </Card>
      <Grid container spacing={2} className={classes.projectsType}>
        <Grid item xs={6} md={5}>
          <Button
            variant={type === 'Dzielnicowy' ? 'contained' : 'outlined'}
            size='large'
            color='primary'
            onClick={() => changeType('Dzielnicowy')}
            className={classes.fullWidth}
          >
            Projekty dzielnicowe
          </Button>
        </Grid>
        <Grid item xs={6} md={5}>
          <Button
            variant={type === 'Ogólnomiejski' ? 'contained' : 'outlined'}
            size='large'
            color='primary'
            onClick={() => changeType('Ogólnomiejski')}
            className={classes.fullWidth}
          >
            Projekty ogólnomiejskie
          </Button>
        </Grid>
      </Grid>
      <Grid container className={classes.rowReverse}>
        <Grid item xs={12} md={4}>
          <FormControl
            variant='outlined'
            fullWidth
            margin='normal'
            size='small'
          >
            <InputLabel id='sort-project-label'>Pokaż dzielnice</InputLabel>
            <Select
              labelId='sort-district-select'
              id='sort-district-select'
              value={district}
              label='Pokaż dzielnice'
              onChange={(e) => setDistrict(e.target.value)}
              style={{ width: '100%' }}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    maxHeight: 48 * 4.5 + 8,
                    maxWidth: 540,
                  },
                },
              }}
            >
              <MenuItem key='dzielnice.all' value=''>
                Wszystkie
              </MenuItem>
              {availableDistricts
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4} className={classes.statusBar}>
          <FormControl
            variant='outlined'
            fullWidth
            margin='normal'
            size='small'
          >
            <InputLabel id='filter-status-label'>Status</InputLabel>
            <Select
              labelId='filter-status-select'
              id='filter-status-select'
              value={status}
              label='Status'
              onChange={(e) => setStatus(e.target.value)}
              style={{ width: '100%' }}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    maxHeight: 48 * 4.5 + 8,
                    maxWidth: 540,
                  },
                },
              }}
            >
              <MenuItem key='status.all' value=''>
                Brak
              </MenuItem>
              {PROJECT_STATUS.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Hidden only={['md', 'lg', 'xl']}>
          <Grid item xs={12}>
            <FormControl
              variant='outlined'
              fullWidth
              margin='normal'
              size='small'
            >
              <InputLabel id='sort-project-label'>Sortowanie</InputLabel>
              <Select
                labelId='sort-project-label'
                id='sort-project'
                value={ordering}
                label='Sortowanie'
                onChange={(e) => setOrdering(e.target.value)}
                style={{ width: '100%' }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5 + 8,
                      maxWidth: 540,
                    },
                  },
                }}
              >
                {SORT_TYPES.map((item) => (
                  <MenuItem
                    key={item.name}
                    value={item.value}
                    classes={{ root: classes.MenuItemroot }}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Hidden>
      </Grid>
      <Hidden only={['xs', 'sm']}>
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <>
                      {header.sortable ? (
                        <TableCell
                          key={header.id}
                          sortDirection={
                            orderBy === header.id ? orderType : false
                          }
                        >
                          <TableSortLabel
                            active={orderBy === header.id}
                            direction={
                              orderBy === header.id ? orderType : 'asc'
                            }
                            onClick={() => onSort(header.id)}
                          >
                            {header.name}
                          </TableSortLabel>
                        </TableCell>
                      ) : (
                        <TableCell>{header.name}</TableCell>
                      )}
                    </>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {projects.map((item, idx) => {
                  const starColor =
                    item.status === 'Wybrany do realizacji'
                      ? theme.palette.success.dark
                      : theme.palette.primary.dark;
                  return (
                    <TableRow
                      className={
                        item.status === 'Wybrany do realizacji'
                          ? classes.wonRow
                          : ''
                      }
                    >
                      <TableCell>{item.number}</TableCell>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>{item.votes_count}</TableCell>
                      <TableCell>
                        {statusLabel(
                          item.status,
                          classes.statusLabel,
                          starColor,
                          item.status === 'Wybrany do realizacji' ? (
                            <StarIcon />
                          ) : (
                            <StarBorderIcon />
                          ),
                        )}
                      </TableCell>
                      <TableCell>
                        <>
                          <IconButton
                            href={`${previewUrl}?projectId=${item.id}`}
                            title='Podgląd'
                            aria-label='Podgląd'
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Hidden>
      <Hidden only={['md', 'lg', 'xl']}>
        {projects.map((item) => (
          <WonProjectCell item={item} />
        ))}
      </Hidden>
    </div>
  );
};

WonProjectsList.propTypes = {
  editionId: PropTypes.string.isRequired,
};

export default WonProjectsList;
